module.exports = __webpack_public_path__ + "static/media/bg3.62f3c897.jpg";